/**
 * Pinch-zoom is allowed app-wide (WCAG 1.4.4; Teo's DEC1, Oct 21 2026), but a
 * page left zoomed in can push a full-screen overlay (map, sheet, sidebar) or the
 * next page off-screen. `resetZoom()` snaps the page back to 100% at those
 * moments: route changes and overlay opens.
 *
 * How: briefly add `maximum-scale=1` to the viewport meta (iOS Safari and Android
 * Chrome then clamp the visual viewport back to 1) and restore the original
 * content a moment later, so pinch-zoom works again right after. A no-op when the
 * page isn't zoomed (desktop, or scale already 1).
 */
let restoreTimer: number | undefined;

export function resetZoom(): void {
  if (typeof window === "undefined") return;
  const vv = window.visualViewport;
  if (!vv || vv.scale <= 1.01) return;
  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return;
  const original = meta.dataset.original ?? meta.content;
  meta.dataset.original = original;
  meta.content = `${original}, maximum-scale=1`;
  window.clearTimeout(restoreTimer);
  restoreTimer = window.setTimeout(() => {
    meta.content = original;
    delete meta.dataset.original;
  }, 300);
}
